import { render, staticRenderFns } from "./ProductSlot.vue?vue&type=template&id=123dcd80&scoped=true&"
import script from "./ProductSlot.vue?vue&type=script&lang=js&"
export * from "./ProductSlot.vue?vue&type=script&lang=js&"
import style0 from "./ProductSlot.vue?vue&type=style&index=0&id=123dcd80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123dcd80",
  null
  
)

export default component.exports